export { default } from './CarouselLoaderPager'
